<template>
  <span v-if="isSingleTick">
    <svg height="16" width="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-tippy>
      <g>
        <path d="M0 0h24v24H0z" fill="none"/>
        <path :fill="fillColor" d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"/>
      </g>
    </svg>
    <tippy class="capitalize">{{ displayStatus }}</tippy>
  </span>
  <span v-else>
    <svg height="16" width="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-tippy>
      <path :fill="fillColor" d="m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z"/>
    </svg>
    <tippy class="capitalize">{{ displayStatus }}</tippy>
  </span>
</template>
<script>

export default {
  name: 'StatusWidget',
  props: ['status'],
  computed: {
    isSingleTick() {
      return this.status === 'new';
    },
    displayStatus() {
      return this.$t(`conversation.status.${this.status}`);
    },
    fillColor() {
      if (this.status === 'read') {
        return 'rgb(37, 99, 235)';
      } else {
        return 'rgb(100, 116, 139)';
      }
    }
  }
}
</script>
